export default __webpack_public_path__ + "static/media/h_112x100.5aed14ec.png";